
import {  firbaseConfigResgistryTypes } from './types'

export const firebaseConfigResgistry:firbaseConfigResgistryTypes={
    webFirebaseConfig:{
        'API Key':'',
        'App Id':'',
        'Auth Domain':'',
        'Project Id':'',
        'Storage Bucket':'',
        'Messaging Sender Id':'',
        'Measurement Id':'',
    },
    androidFirebaseConfig:{
        'API Key':'',
        'App Id':'',
        'Project Id':'',
        'Storage Bucket':'',
        // 'Client Id':'',
        'Sender Id':'',
    },
    iosFirebaseConfig:{
        'API Key':'',
        'App Id':'',
        'Project Id':'',
        'Storage Bucket':'',
        // 'Client Id':'',
        'Sender Id':'',

    }
}